module.exports = __webpack_public_path__ + "img/bagus.529981ca.png";